module.exports = __webpack_public_path__ + "static/media/gaelens_2.95ff6f57.svg";